export default __webpack_public_path__ + "static/media/icon_pen.a58514aa.svg";